<kendo-grid [kendoGridBinding]="alarmasControladas" [selectedKeys]="alarmasControladas_seleccionados" [sortable]="true" [selectable]="{cell:false, checkboxOnly: false, drag: true, enabled: true, mode: 'multiple'}"
            [navigable]="true" filterable="menu" kendoGridSelectBy="id" (cellClick)="alarmasControladas_cellClick($event)">
  <ng-template kendoGridToolbarTemplate position="top">
    <button type="button" (click)="alarmasControladas_onClickEditar()" class="btn btn-success btn-sm mr-1">{{ 'editar' | translate }}</button>
    <button type="button" (click)="alarmasControladas_onClickNuevo()" class="btn btn-primary btn-sm mr-1">{{ 'nuevo' | translate }}</button>
    <button type="button" (click)="alarmasControladas_onClickEliminar(alarmasControladas_content)" class="btn btn-danger btn-sm mr-1" 
           [disabled]="isDeleting || this.user.maquinas<2">{{ 'eliminar' | translate }}</button>
    <!--<button (click)="alarmasControladas_onClickCopiarDe(content)" class="btn btn-danger btn-sm mr-1" [disabled]="isDeleting">{{ 'copiarDe' | translate }}</button>-->
  </ng-template>
  <!--id-->
  <kendo-grid-column width="100%" field="id" hidden="hidden" title="id"></kendo-grid-column>
  <!--checkbox-->
  <kendo-grid-checkbox-column width="4%" showSelectAll="true"></kendo-grid-checkbox-column>
  <!--accion-->
  <kendo-grid-column width="32%" field="accion" title="{{ 'accion' | translate }}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>{{ dataItem.accion | translate }}</span>
    </ng-template>
  </kendo-grid-column>
  <!--texto busqueda-->
  <kendo-grid-column width="32%" field="textobusqueda" title="{{ 'textoBusqueda' | translate }}"></kendo-grid-column>
  <!--descripcion-->
  <kendo-grid-column width="32%" field="descripcion" title="{{ 'descripcion' | translate }}"></kendo-grid-column>
  <!--TRADUCCIÓN TEXTOS DEL GRID-->
  <kendo-grid-messages filter="{{'filter' | translate}}" filterAfterOperator="{{'filterAfterOperator' | translate}}"
  filterAfterOrEqualOperator="{{'filterAfterOrEqualOperator' | translate}}"
  filterAndLogic="{{'filterAndLogic' | translate}}" filterBeforeOperator="{{'filterBeforeOperator' | translate}}"
  filterBeforeOrEqualOperator="{{'filterBeforeOrEqualOperator' | translate}}"
  filterBooleanAll="{{'filterBooleanAll' | translate}}" filterClearButton="{{'filterClearButton' | translate}}"
  filterContainsOperator="{{'filterContainsOperator' | translate}}"
  filterDateToday="{{'filterDateToday' | translate}}" filterDateToggle="{{'filterDateToggle' | translate}}"
  filterEndsWithOperator="{{'filterEndsWithOperator' | translate}}"
  filterEqOperator="{{'filterEqOperator' | translate}}" filterFilterButton="{{'filterFilterButton' | translate}}"
  filterGtOperator="{{'filterGtOperator' | translate}}" filterGteOperator="{{'filterGteOperator' | translate}}"
  filterIsEmptyOperator="{{'filterIsEmptyOperator' | translate}}" filterIsFalse="{{'filterIsFalse' | translate}}"
  filterIsNotEmptyOperator="{{'filterIsNotEmptyOperator' | translate}}"
  filterIsNotNullOperator="{{'filterIsNotNullOperator' | translate}}"
  filterIsNullOperator="{{'filterIsNullOperator' | translate}}" filterIsTrue="{{'filterIsTrue' | translate}}"
  filterLtOperator="{{'filterLtOperator' | translate}}" filterLteOperator="{{'filterLteOperator' | translate}}"
  filterNotContainsOperator="{{'filterNotContainsOperator' | translate}}"
  filterNotEqOperator="{{'filterNotEqOperator' | translate}}"
  filterNumericDecrement="{{'filterNumericDecrement' | translate}}"
  filterNumericIncrement="{{'filterNumericIncrement' | translate}}" filterOrLogic="{{'filterOrLogic' | translate}}"
  filterStartsWithOperator="{{'filterStartsWithOperator' | translate}}" loading="{{'loading' | translate}}"
  groupPanelEmpty="{{'groupPanelEmpty' | translate}}" lock="{{'lock' | translate}}" unlock="{{'unlock' | translate}}"
  noRecords="{{'norecords' | translate}}" pagerItems="" pagerOf="/"></kendo-grid-messages>
</kendo-grid>

<!--POPUP ELIMINAR-->
<ng-template #alarmasControladas_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"></h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ 'preguntaeliminarpopup' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">{{ 'no' | translate }}</button>
    <button type="button" class="btn btn-danger" (click)="alarmasControladas_eliminarRegistro(alarmasControladas_contentloading)" 
       [disabled]="this.user.maquinas<2">{{ 'si' | translate }}</button>
  </div>
</ng-template>

<ng-template #alarmasControladas_contentloading let-modal>
  <div class="modal-body">
    <p>{{ 'eliminando' | translate }}</p>
    <div class="spinner-border" role="status">
      <span class="sr-only">{{ 'eliminando' | translate }}...</span>
    </div>
  </div>
</ng-template>
